module.exports = __webpack_public_path__ + "img/Componente 36 – 1.a0070fae.svg";